import Load from '@/components/Load';
import { useEffect, useRef, useState } from 'react';
import MemberApi from '../api';
import { useErrorBoundary } from 'react-error-boundary';
import useEnvInitData from '@/hooks/useEnvInitData'
import { useHapticFeedback } from '@vkruglikov/react-telegram-web-app';
import { useDispatch, useSelector } from 'react-redux';
import { getRaffle, setRaffle } from '@/features/Raffle/reducer';
import { getUser, setUser } from '@/modules/User/reducer';
import Captcha from '../../../components/Captcha';
// import { Turnstile } from '@marsidev/react-turnstile';

export default function MemberCreate() {
  	// const refCaptcha = useRef()
	const { showBoundary } = useErrorBoundary()
	const [InitDataUnsafe, InitData] = useEnvInitData();
	const [impactOccurred, notificationOccurred] = useHapticFeedback();
	const raffle = useSelector(getRaffle)
	const dispatch = useDispatch()
	const user = useSelector(getUser)
	const [showOwnCaptcha, setShowOwnCaptcha] = useState(true)

	const handleCreate = (captcha = []) => {
		if (raffle.captcha && !showOwnCaptcha) return;
		setShowOwnCaptcha(false)

		MemberApi.create({
			initData: InitData,
			param: InitDataUnsafe.start_param,
			captcha: captcha,
			challenge: raffle.captcha.challenge,
			// token: refCaptcha.current ? refCaptcha.current.getResponse() : ''
		}).then(function(result) {
			if (result.user) {
				notificationOccurred('success')
				dispatch(setUser({
					...user,
					...result.user,
				}))
			} else if (result.captcha) {
				setShowOwnCaptcha(true);
				// refCaptcha.current.reset();
				dispatch(setRaffle({
					...raffle,
					captcha: result.captcha
				}))
			} else {
				notificationOccurred('error')
			}
		}).catch((e) => {
			showBoundary(e)
		})
	}

	useEffect(() => {
		if (raffle && !raffle.captcha) {
			handleCreate()
		}
	}, [raffle])

	return (
		<div className='MemberCreate'>
			<Load/>
			{raffle.captcha ?
				<>
					{/* <Turnstile
						ref={refCaptcha}
						siteKey='0x4AAAAAAAgDD8CYN_YpvXoS'
						onSuccess={() => setShowOwnCaptcha(true)}
						options={{
							size: 'flexible'
						}}
					/> */}
					{showOwnCaptcha && <Captcha data={raffle.captcha} submit={handleCreate} />}
				</>
			: null}
		</div>
	)
}
